import { ArrowRight } from "lucide-react";

const steps = [
  {
    number: "01",
    title: "Tell us your needs",
    description:
      "Share your technical requirements and team preferences with us.",
  },
  {
    number: "02",
    title: "Meet pre-vetted developers",
    description:
      "We'll match you with developers who perfectly fit your requirements.",
  },
  {
    number: "03",
    title: "Start risk-free trial",
    description:
      "Work with your chosen developer for a trial period to ensure satisfaction.",
  },
];

export const HowItWorks = () => {
  return (
    <section id="how-it-works" className="py-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl font-bold text-primary mb-4">
            How It Works
          </h2>
          <p className="text-gray-600 max-w-2xl mx-auto">
            Our streamlined process makes it easy to find and hire the perfect
            developer for your team.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          {steps.map((step, index) => (
            <div key={step.number} className="relative">
              <div className="flex flex-col items-center text-center">
                <span className="text-4xl font-bold text-secondary/20 mb-4">
                  {step.number}
                </span>
                <h3 className="text-xl font-semibold mb-2">{step.title}</h3>
                <p className="text-gray-600">{step.description}</p>
              </div>
              {index < steps.length - 1 && (
                <ArrowRight className="hidden md:block absolute top-8 -right-4 w-8 h-8 text-gray-300" />
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};